<template>
  <div class="content content_top_margin_none">
    <div class="content_inner">
      <!-- <div
        class="title_outer title_without_animation title_text_shadow with_image" data-height="230">
        <div class="title title_size_large position_left" style="height:230px;background-color:#f8f8f8;">
          <div  class="img-ss">
            <img  src="../assets/images/headerimg/Header_1920x380_contact-us.jpg" class="gens-img"> 
            <h1  class="gens-title">{{$t('ContractText.ContactUs')}}</h1>
          </div>
        </div>
      </div> -->
       <banner>
            <img src="../assets/images/headerimg/Header_1920x380_contact-us.jpg"/>
            <div slot="title">{{$t('ContractText.ContactUs')}}</div>
        </banner>
      <div class="full_width">
        <div class="full_width_inner">
          <div class="vc_row wpb_row section vc_row-fluid" style=" text-align:left;">
            <div class="full_section_inner clearfix">
              <div class="wpb_column vc_column_container vc_col-sm-12">
                <div class="vc_column-inner">
                  <div class="wpb_wrapper">
                    <div class="wpb_raw_code wpb_content_element wpb_raw_html">
                      <div class="wpb_wrapper">
                        <meta name="format-detection" content="telephone=no" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="vc_row wpb_row section vc_row-fluid grid_section" style=" padding-top:60px; padding-bottom:30px; text-align:left;">
            <div class="section_inner clearfix">
              <div class="section_inner_margin clearfix">
                <div class="wpb_column vc_column_container vc_col-sm-12">
                  <div class="vc_column-inner">
                    <div class="wpb_wrapper">
                      <div class="wpb_text_column wpb_content_element">
                        <div class="wpb_wrapper">
                          <h2 style="text-align: center;">{{$t('ContractText.quickContactYou')}}</h2>
                        </div>
                      </div>
                      <div class="separator small center" style="margin-top: 10px;margin-bottom: 30px;background-color: #51cedd;"></div>
                      <div class="vc_row wpb_row section vc_row-fluid vc_inner" style=" text-align:left;">
                        <div class="full_section_inner clearfix">
                          <div class="wpb_column vc_column_container vc_col-sm-6">
                            <div class="vc_column-inner vc_custom_1573569088514">
                              <div class="wpb_wrapper">
                                <div role="form" class="wpcf7" id="wpcf7-f6-p495-o1" lang="en-US" dir="ltr" >
                                  <div class="screen-reader-response"></div>
                                  <div   method="post" class="wpcf7-form cf7_custom_style_1" novalidate="novalidate" >
                                    
                                    <p>
                                      <label>
                                        {{$t('ContractText.namemust')}}
                                        <br />
                                        <span class="wpcf7-form-control-wrap your-name">
                                          <input
                                            type="text" required="required"
                                            name="your-name"
                                            value
                                            size="40"
                                            class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                            aria-required="true"
                                            aria-invalid="false"
                                            id="Name"
                                          />
                                        </span>
                                      </label>
                                    </p>
                                    <p>
                                      <label>
                                          {{$t('ContractText.phonemust')}}
                                        <br />
                                        <span class="wpcf7-form-control-wrap your-tel">
                                          <input required="required"
                                            type="tel"
                                            name="your-tel"
                                            value
                                            size="40"
                                            class="wpcf7-form-control wpcf7-text wpcf7-tel wpcf7-validates-as-required wpcf7-validates-as-tel"
                                            aria-required="true"
                                            aria-invalid="false"
                                            id="Phone"
                                          />
                                        </span>
                                      </label>
                                    </p>
                                    <p>
                                      <label>
                                         {{$t('ContractText.emailmust')}}
                                        <br />
                                        <span class="wpcf7-form-control-wrap your-email">
                                          <input
                                            type="email" required="required"
                                            name="your-email"
                                            value
                                            size="40"
                                            class="wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email"
                                            aria-required="true"
                                            aria-invalid="false"
                                            id="Email"
                                          />
                                        </span>
                                      </label>
                                    </p>
                                    <p>
                                      <label>
                                        {{$t('ContractText.topic')}}
                                        <br />
                                        <span class="wpcf7-form-control-wrap your-subject">
                                          <input
                                            type="text"
                                            name="your-subject"
                                            value
                                            size="40"
                                            class="wpcf7-form-control wpcf7-text"
                                            aria-invalid="false"
                                            id="Subject"
                                          />
                                        </span>
                                      </label>
                                    </p>
                                    <p>
                                      <label>
                                          {{$t('ContractText.content')}}
                                        <br />
                                        <span class="wpcf7-form-control-wrap your-message">
                                          <textarea
                                            name="your-message"
                                            cols="40"
                                            rows="10"
                                            class="wpcf7-form-control wpcf7-textarea"
                                            aria-invalid="false"
                                            id="leafcontent"
                                          ></textarea>
                                        </span>
                                      </label>
                                    </p>
                                    <div>
                                      <el-button
                                        class="submit_button"
                                        @click="submitForm">
                                        <span v-if="$i18n.locale!='en-US'">
                                        提交</span>
                                        <span v-if="$i18n.locale=='en-US'">Submit</span>
                                        </el-button>
                                    </div>
                                    <div class="wpcf7-response-output wpcf7-display-none"></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="wpb_column vc_column_container vc_col-sm-6">
                            <div class="vc_column-inner">
                              <div class="wpb_wrapper">
                                <div class="wpb_text_column wpb_content_element">
                                  <div class="wpb_wrapper">
                                    <h4 style="text-align: left; color: #368da7;">
                                      <strong>{{$t('ContractText.company_full_name')}}</strong>
                                    </h4>
                                  </div>
                                </div>
                                <div
                                  class="separator transparent"
                                  style="margin-top: 5px;margin-bottom: 5px;"
                                ></div>

                                <div class="wpb_text_column wpb_content_element">
                                  <div class="wpb_wrapper">
                                    <p>
                                      {{$t('ContractText.tel')}}：(+852) 2865 9399 (報告查詢時段10:30-18:00)
                                      <br />{{$t('ContractText.fax')}}：(+852) 2865 9600
                                      <br />{{$t('ContractText.email')}}：info@hkfirstchoice.com
                                      <br />{{$t('ContractText.address')}}：{{$t('ContractText.company_address')}}
                                    </p>
                                  </div>
                                </div>
                                <div class="vc_empty_space" style="height: 30px">
                                  <span class="vc_empty_space_inner">
                                    <span class="empty_space_image"></span>
                                  </span>
                                </div>

                                <div class="wpb_single_image wpb_content_element vc_align_left">
                                  <div class="wpb_wrapper">
                                    <a
                                      href="https://www.google.com/maps/dir/%E7%81%AB%E7%82%AD%E7%AB%99+%E7%81%AB%E7%82%AD/%E7%81%AB%E7%82%AD%E7%A6%BE%E7%9B%9B%E8%A1%9711%E8%99%9F%E4%B8%AD%E5%BB%BA%E9%9B%BB%E8%A8%8A%E5%A4%A7%E5%BB%88/@22.3963122,114.1957026,17z/data=!3m1!4b1!4m14!4m13!1m5!1m1!1s0x340406360d07b8fd:0x35050ec6ba9a8b19!2m2!1d114.1983372!2d22.3953695!1m5!1m1!1s0x340406369d2c3903:0x8927ea853682037c!2m2!1d114.1975326!2d22.397255!3e2"
                                      target="_blank"
                                    >
                                      <div class="vc_single_image-wrapper vc_box_border_grey">
                                        <img
                                          width="620"
                                          height="503"
                                          src="../assets/images/map.png"
                                          class="vc_single_image-img attachment-full"
                                          alt
                                          srcset="../assets/images/map.png 620w, ../assets/images/map.png 300w"
                                          sizes="(max-width: 620px) 100vw, 620px"
                                          data-pagespeed-url-hash="2439344996"
                                        />
                                      </div>
                                    </a>
                                  </div>
                                </div>
                                <div class="vc_empty_space" style="height: 30px">
                                  <span class="vc_empty_space_inner">
                                    <span class="empty_space_image"></span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content_bottom"></div>
    </div>
  </div>
</template>
<script>
var height = $(window).height();
var point = [114.208856, 22.400393];
var map;
import {ConsultionInfo} from '@/service/searchreport'
import banner from '@/components/banner'
export default {
  data() {
    return {
      consultationForm: {}
    };
  },
  components: {
      banner,
     
    },
  mounted() {

  },
  watch: {
    
  },
  methods: {
    // loadMap() {
    //   map = new AMap.Map("allmap", {
    //     zoom: 20, //级别
    //     center: point, //中心点坐标
    //     city: "香港",
    //     lang: this.$store.state.lang == "zh-TCC" ? "zh_en" : "en" //可选值：en，zh_en, zh_cn
    //   });
    //   var marker = new AMap.Marker({
    //     //添加标注
    //     position: point
    //   });
    //   map.add(marker); //添加到地图
    // },
    setMapHeight() {
      let navbarHeight = $(".ct-header.navbar").height();
      let companyHeight = $(".company").outerHeight();
      $(".map").height(height - navbarHeight - companyHeight);
    },
    submitForm() {
      var Name = document.getElementById("Name").value;
      var Phone = document.getElementById("Phone").value;
      var Email = document.getElementById("Email").value;
      var subject=document.getElementById("Subject").value;
      var leafcontent = document.getElementById("leafcontent").value;
      console.log('selectType',Name,Phone,Email,subject,leafcontent);
     
     
      if (Name == "") {
       alert("請輸入姓名！")
        return;
      }
      if (Phone == "") {
        alert("請輸入電話號碼！");
        return;
      }
      if (Email == "") {
        alert("請輸入郵箱！");
        return;
      }
      if(subject==""){
        alert("請輸入主題");
        return ;
      }
      
      $.ajax({
        type: "get",
        url: process.env.BASE_URL + "/api/consultation/ConsultionInfo",
        contentType: "application/x-www-form-urlencoded",
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        data: {
         
          Name: Name,
          Phone: Phone,
          Email: Email,          
          Subject:subject,
          LeavingMessage: leafcontent
        },

        success: function(resp) {
          if (resp.Status == true) {
            alert("感谢您的留言，我们将尽快与您取得联系！");
          } else {
            alert("网络连接失败");
          }
        }
      });
    },
    async ConsultionInfo(Name, Phone, Email, Subject, LeavingMessage){
            let resp=await ConsultionInfo(Name, Phone, Email, Subject, LeavingMessage);
            if(resp.Status){
               if(resp.Status==true){
                    alert("感謝您的留言，我們將盡快與您取得聯繫！");
                }else{
                    alert("留言出錯："+resp.Msg)
                }
            }else{
                 alert("網絡連接失敗");
            }
        },
  }
};
</script>

<style lang="scss" scoped>
.content.content_top_margin_none {
    background-color: #fff;
    margin-top: 0!important;
    width:100%;
    overflow: hidden;
}
.content {
    margin-top: -90px;
}
.title_outer.with_image .title {
    height: auto!important;
    line-height: normal;
    background: 0 0;
}
.img-ss{

        position: relative;
        .gens-img{
            max-width: 100%;
            height: auto;
            position: relative;
        }
         .gens-title{
                    width: 100%;
                    height: 100%;
                    font-size: 47px;
                    line-height: 60px;
                    color: #fff;
                    position: absolute;
                    display: flex;
                    justify-content: left;
                    align-items: center;
                    padding-left:10%;
                    padding-right:10%;
                    font-weight: bold;
                    top:0;
            }
    }
.title img {
    width: 100%;
    display: block;
    position: relative;
}
img {
    max-width: 100%;
    height: auto;
    image-rendering: optimizeQuality;
}
h2, .h2, h2 a {
    color: #368da7;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    text-transform: none;
}
.separator.small {
    background-color: #51cedd;
    height: 2px;
    position: relative;
    width: 22px;
    display: block;
    margin: 10px auto 20px;
}
.title_outer.with_image .title {
    height: auto!important;
    line-height: normal;
    background: 0 0;
    text-align: left;
}
.title_outer.with_image .title .title_holder {
    position: absolute;
    top: 0;
    display: block;
}
.title .title_holder {
    display: table;
    height: 100%;
    left: 0;
    position: relative;
    width: 100%;
}
.content .title_outer.with_image .title .container_inner{

    display: table;
    height: 100%;
}
.clearfix:after, .clearfix:before {
    content: " ";
    display: table;
}
.title_outer.with_image .title .title_subtitle_holder {
    display: table-cell;
    vertical-align: middle;
    width: 100%;
}
.title_subtitle_holder {
    display: block;
    padding: 0;
    position: relative;
}
.clearfix:after, .drop_down .wide .second ul li:nth-child(4n+1) {
    clear: both;
}
.clearfix:after, .clearfix:before {
    content: " ";
    display: table;
}
.vc_row:before {
    content: " ";
    display: table;
}
div.section {
  position: relative;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
}
.vc_row {
    margin-left: -15px;
    margin-right: -15px;
}
.wpb_row {
  margin-bottom: 0!important;
}
.full_section_inner {
    position: relative;
    z-index: 20;
    width: 65%;
    margin: auto;
    text-align: center
}

  .section_inner {
    margin: 0 auto;
    position: relative;
    z-index: 20;
    text-align: left;
}

.vc_column_container {
    padding-left: 0;
    padding-right: 0;
}
.vc_col-sm-6 {
    width: 50%;
    float: left;
}
.vc_column_container>.vc_column-inner {
    box-sizing: border-box;
    padding-left: 15px;
    padding-right: 15px;
    width: 100%;
}
.vc_custom_1573569088514 {
    margin-bottom: 40px!important;
}
.vc_column-inner::before {
    content: " ";
    display: table;
}
div.wpcf7 .screen-reader-response {
    position: absolute;
    overflow: hidden;
    clip: rect(1px,1px,1px,1px);
    height: 1px;
    width: 1px;
    margin: 0;
    padding: 0;
    border: 0;
}
form{
  display: block;
  background: 0 0;
    border: 0;
    margin: 0;
    padding: 0;
    vertical-align: baseline;
    outline: 0;
}
.wpcf7 form.wpcf7-form p {
    margin-bottom: 20px;
}
p {
    color: #3a3a3a;
    font-size: 16px;
    line-height: 24px;
    font-style: normal;
    font-weight: 400;
}
 .cf7_custom_style_1  input.wpcf7-form-control.wpcf7-text{
   background-color: #f8f8f8;
    border-color: #e9e9e9;
    border-width: 1px;
    border-style: solid;
    border-top: none;
    border-left: none;
    border-right: none;
    color: #797e81;
    font-family: Arial;
    font-size: 14px;
    line-height: 18px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0;
    text-transform: none;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-bottom: 10px;
}
span{
      background: 0 0;
    border: 0;
    margin: 0;
    padding: 0;
    vertical-align: baseline;
    outline: 0;

}
.wpcf7-form-control-wrap {
    position: relative;
}
input.wpcf7-form-control.wpcf7-text{
      border: 1px solid #267dc2;
      display: block;
    margin: 5px 0 0;
    padding: 15px;
    border: 0;
    border-radius: 0;
    outline: 0;
    resize: none;
    font-size: 13px;
    line-height: 17px;
    background-color: #fff;
    color: #818181;
    font-family: Raleway;
    font-weight: 400;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-appearance: none;
}
input.wpcf7-form-control.wpcf7-text{
  width:100% !important;
}

input {
    -webkit-writing-mode: horizontal-tb !important;
    text-rendering: auto;
    color: -internal-light-dark-color(black, white);
    letter-spacing: normal;
    word-spacing: normal;
    text-transform: none;
    text-indent: 0px;
    text-shadow: none;
    display: inline-block;
    text-align: start;
    -webkit-appearance: textfield;
    background-color: -internal-light-dark-color(white, black);
    -webkit-rtl-ordering: logical;
    cursor: text;
    margin: 0em;
    font: 400 13.3333px Arial;
    padding: 1px 0px;
    border-width: 2px;
    border-style: inset;
    border-color: initial;
    border-image: initial;
}
.wpcf7 form.wpcf7-form p {
    margin-bottom: 20px;
}
p {
    color: #3a3a3a;
    font-size: 16px;
    line-height: 24px;
    font-style: normal;
    font-weight: 400;
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}
.cf7_custom_style_1 input.wpcf7-form-control.wpcf7-submit:hover, .cf7_custom_style_1 input.wpcf7-form-control.wpcf7-submit:not([disabled]):hover {
    color: #fff;
    background-color: #51cedd;
}
.cf7_custom_style_1 input.wpcf7-form-control.wpcf7-submit, .cf7_custom_style_1 input.wpcf7-form-control.wpcf7-submit:not([disabled]) {
    background-color: #368da7;
    border-width: 0;
    color: #fff;
    font-family: Arial;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: 0;
    text-transform: capitalize;
    height: 35px;
    line-height: 35px;

}
input.wpcf7-form-control.wpcf7-submit {
    position: relative;
    display: inline-block;
    width: auto;
    height: 39px;
    line-height: 36px;
    margin: 0;
    padding: 0 23px;
    font-size: 13px;
    font-weight: 700;
    font-family: Raleway,sans-serif;
    text-align: left;
    text-decoration: none;
    cursor: pointer;
    white-space: nowrap;
    outline: 0;
    font-style: normal;
    text-transform: uppercase;
    letter-spacing: 1px;
    -o-border-radius: 4px;
    -moz-border-radius: 4px;
    -webkit-border-radius: 4px;
    -ms-border-radius: 4px;
    border-radius: 4px;
    text-shadow: none;
    background-color: transparent;
    -webkit-transition: all .1s linear;
    -moz-transition: all .1s linear;
    -ms-transition: all .1s linear;
    -o-transition: all .1s linear;
    transition: all .1s linear;
    -webkit-box-sizing: initial;
    -moz-box-sizing: initial;
    box-sizing: initial;
}
div.wpcf7 .ajax-loader {
    visibility: hidden;
    display: inline-block;
    background-image: url(/wp-content/plugins/contact-form-7/images/ajax-loader.gif.pagespeed.ce.r5YrN3eaRD.gif);
    width: 16px;
    height: 16px;
    border: none;
    padding: 0;
    margin: 0 0 0 4px;
    vertical-align: middle;
}
.wpb_wrapper{
  text-align: left;
}
.cf7_custom_style_1 textarea.wpcf7-form-control.wpcf7-textarea {
    height: 250px;
        background-color: #f8f8f8;
    border-color: #e9e9e9;
    border-width: 1px;
    border-style: solid;
    border-top: none;
    border-left: none;
    border-right: none;
    color: #797e81;
    font-family: Arial;
    font-size: 14px;
    line-height: 18px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0;
    text-transform: none;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-bottom: 10px;
}
p{
  display: grid;
}
textarea.wpcf7-form-control.wpcf7-textarea{
  
    border: 1px solid #267dc2;
    
}
textarea.wpcf7-form-control.wpcf7-textarea {
    display: block;
    margin: 5px 0 0;
    padding: 15px;
    border: 0;
    border-radius: 0;
    outline: 0;
    resize: none;
    font-size: 13px;
    line-height: 17px;
    background-color: #fff;
    color: #818181;
    font-family: Raleway;
    font-weight: 400;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-appearance: none;
}
 textarea.wpcf7-form-control.wpcf7-textarea {
    width: 100%;
}
label{
  background: 0 0;
    border: 0;
    margin: 0;
    padding: 0;
    vertical-align: baseline;
    outline: 0;
}
.wpcf7-form-control:active{
  border-bottom:1px solid #51cedd !important;
}
.wpcf7-form-control:hover{
  border-bottom:1px solid #51cedd !important;
}
.submit_button:not([disabled]){
    background-color: #368da7;
    border-width: 0;
    color: #fff;
    font-family: Arial;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: 0;
    text-transform: capitalize;
    // height: 35px;
    // line-height: 35px;
    border-color: #368da7;
    border-radius: 4px;
}
.submit_button{
    background-color: #368da7;
    padding:10px 20px;
    border-radius: 4px;
    cursor: pointer;
}
.title_outer .has_background.title .title_holder, .title_outer .has_fixed_background.title .title_holder, .title_outer.with_image .title .title_holder {
    position: absolute;
    top: 0;
    display: block;
}
.title .title_holder {
    display: table;
    height: 100%;
    left: 0;
    position: relative;
    width: 100%;
}
.title_outer .has_background.title .title_holder .container, .title_outer .has_fixed_background.title .title_holder .container, .title_outer.with_image .title .title_holder .container {
    display: block;
    height: 100%;
}
.title .title_holder .container {
    display: table-cell;
    vertical-align: middle;
    background-color: transparent;
}
.content .title_outer.with_image .title .container_inner{
      display: table;
    height: 100%;
}
.title_outer.with_image .title .title_subtitle_holder {
    display: table-cell;
    vertical-align: middle;
    width: 100%;
}
.container_inner {
    position: relative;
}
.content .title .container_inner {
    padding: 0!important;
}
.title_subtitle_holder {
    display: block;
    padding: 0;
    position: relative;
}

.title_subtitle_holder_inner {
    position: relative;
}

</style>

<style>
.amap-logo {
  display: none !important;
}

.amap-copyright {
  bottom: -100px;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/view/contact.vue